export default {
    getShowLoading(state){
        return state.showLoading;
    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js